import { render, staticRenderFns } from "./BuyLeads.vue?vue&type=template&id=7cef1f16&scoped=true&"
import script from "./BuyLeads.vue?vue&type=script&lang=js&"
export * from "./BuyLeads.vue?vue&type=script&lang=js&"
import style0 from "./BuyLeads.vue?vue&type=style&index=0&id=7cef1f16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cef1f16",
  null
  
)

export default component.exports